angular.module('rjmNg.directives').directive "dashboardStoreFilter", [
  () ->
    bindToController: true
    controllerAs: "view"
    restrict: "E"
    scope: {}
    templateUrl: "directive.dashboardStoreFilter.html"
    controller: [
      "$rootScope"
      "$routeParams"
      "MagentoStores"
      "dashboardService"
      "Clients"
      "FEATURE_TIER"
      (
        $rootScope
        $routeParams
        MagentoStores
        dashboardService
        Clients
        FEATURE_TIER
      ) ->

        view = @

        ALL_STORES = "All Stores"
        view.stores = []
        view.storeIds = []
        view.searchTerm = ""
        view.groupName = ""
        view.filteredStore = dashboardService.extraDashboardFilters?[0]?.name or ALL_STORES
        view.filteredStoreId = dashboardService.extraDashboardFilters?[0]?.id or 0
        view.isEnabled = false
        view.isGroupStoreMapFeature = false
        view.loading = true
        view.dashboardLoaded = true

        view.clickedFilterButton = () ->
          view.searchTerm = ''
          $rootScope.$broadcast("openedStoreFilterDropdown")

        view.filterByStore = (store) ->
          view.filteredStore = store.name
          view.filteredStoreId = store.id

          storeFilter = []
          if store.name isnt ALL_STORES
            storeFilter = [
              field: "store_id" # column from table customer_entity
              operator: "="
              value: store.id
              name: store.name
            ]
          if view.isGroupStoreMapFeature and store.name is ALL_STORES
            storeFilter = [
                    field: "store_id" # column from table customer_entity
                    operator: "IN"
                    value: view.storeIds
            ]
          
          dashboardService.extraDashboardFilters = storeFilter
          $rootScope.$broadcast("reloadWithStoreFilter", storeFilter)

        $rootScope.$on "dashboardItemsLoadEnd", ->
          view.dashboardLoaded = true

        $rootScope.$on "dashboardItemsLoadStart", ->
          view.dashboardLoaded = false

        @$onInit = () ->
          Clients.get($routeParams.clientId)
          .then ({properties}) ->
            {enable_store_dwf, feature_tier, is_group_store_access} = properties
            view.isEnabled = feature_tier is FEATURE_TIER.BASIC.toString() or enable_store_dwf is "1"
            view.isGroupStoreMapFeature = is_group_store_access is "1"
            if view.isEnabled
              MagentoStores($routeParams.clientId).getAll {}, ({data,group_access_name}) ->
                if is_group_store_access
                  if group_access_name
                    view.groupName = group_access_name
                  else
                    view.groupName = 'default'
                availableStores = data.body.map ([id, name]) ->
                  name = _.unescape name
                  view.storeIds.push(id)
                  {id, name}
                availableStores.push
                  id: 0
                  name: ALL_STORES
                view.stores = availableStores
                view.loading = false
        view
    ]
]
